import ChangeTripsModalAlert from '@/components/manage/change-trips/ChangeTripsModalAlert';
import JourneyOfferList from '@/components/purchase/journey/JourneyOfferList';
import { outboundJourneysLoadingSelector } from '@/features/loading/loadingSelectors';
import {
  setSelectedOutboundOfferMapByLegId,
  updateSelectedOutboundOfferMapByLegId,
} from '@/features/purchase/purchaseActions';
import {
  inboundDataSelector,
  outboundDataSelector,
  selectedOutboundOfferMapSelector,
} from '@/features/purchase/purchaseSelectors';
import { useChangeTravelClass } from '@/hooks/useChangeTravelClass';
import { useJourneyOfferContinue } from '@/hooks/useJourneyOfferContinue';
import { TransText } from '@/i18n/trans/text';
import { useDispatch, useSelector } from '@/store/utils';
import { getDefaultOfferMap } from '@/utils/purchase';
import { getJourneyWarnings } from '@/utils/warning';
import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const OutboundJourneyOfferList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const outboundData = useSelector(outboundDataSelector);
  const inboundData = useSelector(inboundDataSelector);
  const isLoading = useSelector(outboundJourneysLoadingSelector);
  const {
    isChangeTravelClassFlow,
    getChangeTravelClassOffers,
    handleGoBack: handleChangeTravelClassFlowGoBack,
    showStartExchangeError,
  } = useChangeTravelClass({
    isOutbound: true,
  });
  const {
    onContinue,
    changeTravelClassAlert,
    handleAlertBack,
    handleAlertContinue,
    booking,
  } = useJourneyOfferContinue({
    isOutbound: true,
    isChangeTravelClassFlow,
    hasInboundJourneys: !!inboundData.journeys,
    getChangeTravelClassOffers,
    showStartExchangeError,
  });
  const selectedJourneyWarnings = useMemo(
    () =>
      getJourneyWarnings(outboundData.selectedJourney, outboundData.warnings),
    [outboundData.selectedJourney, outboundData.warnings]
  );

  useEffect(() => {
    if (!outboundData.selectedJourney && !outboundData.journeys) {
      if (isChangeTravelClassFlow) {
        getChangeTravelClassOffers();
        return;
      }
      navigate('/purchase');
      return;
    }
    if (outboundData.selectedJourney) {
      dispatch(
        setSelectedOutboundOfferMapByLegId(
          getDefaultOfferMap(outboundData.selectedJourney)
        )
      );
    }
  }, [
    dispatch,
    getChangeTravelClassOffers,
    isChangeTravelClassFlow,
    navigate,
    outboundData.journeys,
    outboundData.selectedJourney,
  ]);

  return (
    <>
      <ChangeTripsModalAlert
        alert={changeTravelClassAlert}
        booking={booking}
        isOpen={Boolean(changeTravelClassAlert)}
        onBack={handleAlertBack}
        onClose={handleAlertBack}
        onContinue={handleAlertContinue}
        selectedTrip={outboundData.selectedJourney}
      />
      <JourneyOfferList
        title={<TransText i18nKey="selectOutboundTicket" />}
        selectedJourney={outboundData.selectedJourney}
        isOutbound
        updateSelectedOfferMap={updateSelectedOutboundOfferMapByLegId}
        selectedOfferMapByLegIdSelector={selectedOutboundOfferMapSelector}
        isLoading={isLoading}
        warnings={selectedJourneyWarnings}
        onContinue={onContinue}
        onGoBack={
          isChangeTravelClassFlow
            ? handleChangeTravelClassFlowGoBack
            : () => navigate(-1)
        }
      />
    </>
  );
};

export default OutboundJourneyOfferList;
